import { gql } from '@apollo/client';

export const GetOrganizations = gql`
  query GetOrganizations {
    organizations {
      edges {
        node {
          code
          name
          description
          dateCreation
        }
      }
      pageInfo {
        hasNextPage
      }
      totalCount
    }
  }
`;